import React from "react";

function LatestActivity({ data }) {
  return (
    <>
      <div className="p-1">
        {data?.length > 0 ? (
          data?.map((item, index) => (
            <div key={index} className="p-2 mb-2 latest-div">
              <div className="d-flex align-items-center justify-content-between p-1">
                <div className="d-flex align-items-center">
                  <span className="fa-solid fa-circle text-success d-inline-flex fs-10 me-2"></span>
                  <div>
                    <p className="text-truncate mb-0">
                      <span className="fw-bold fs-16 text-dark mb-1 me-1">
                        {item?.company_name}
                      </span>
                      <span className="text-muted fs-12 fw-medium">
                        - {item?.meeting_with}
                      </span>
                    </p>
                    <p className="text-muted op-7 fs-10">{item?.notes}</p>
                  </div>
                </div>
                <div>
                  <p className="text-truncate fs-12 mb-0">
                    <i className="fa-regular fa-clock text-danger text-opacity-50"></i>{" "}
                    {new Date(item?.meeting_date).toLocaleDateString("en-CA")}
                  </p>
                  <span className="text-muted fs-12 fw-medium">
                    {item?.meeting_by}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <span className="text-danger">No Data Available</span>
        )}
      </div>
    </>
  );
}

export default LatestActivity;
